<template>
  <div class="w-full flex flex-col mx-auto">
    <Hero></Hero>
    <Selection></Selection>
    <Grid></Grid>
    <News></News>
    <Content></Content>
    <Supporter></Supporter>
  </div>
</template>

<script>
import Hero from '@/sections/Hero.vue';
import Selection from '@/sections/Selection.vue';
import Content from '@/sections/Content.vue';
import Supporter from '@/sections/Supporter.vue';
import Grid from '@/sections/Grid.vue';
import News from '@/sections/News.vue';

export default {
  name: 'Home',
  components: {
    Hero,
    Selection,
    Content,
    Supporter,
    Grid,
    News
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>